module.exports = "/images/vendor/flag-icon-css/flags/1x1/no.svg?b7a21f544f617a59abff3dac02d9101b";